const buttonGroupDividerColor: object = {
  white: {
    divideColor: "divide-blue-gray-50",
  },
  "blue-gray": {
    divideColor: "divide-blue-gray-600",
  },
  gray: {
    divideColor: "divide-gray-600",
  },
  brown: {
    divideColor: "divide-brown-600",
  },
  "deep-orange": {
    divideColor: "divide-deep-orange-600",
  },
  orange: {
    divideColor: "divide-orange-600",
  },
  amber: {
    divideColor: "divide-amber-600",
  },
  yellow: {
    divideColor: "divide-yellow-600",
  },
  lime: {
    divideColor: "divide-lime-600",
  },
  "light-green": {
    divideColor: "divide-light-green-600",
  },
  green: {
    divideColor: "divide-green-600",
  },
  teal: {
    divideColor: "divide-teal-600",
  },
  cyan: {
    divideColor: "divide-cyan-600",
  },
  "light-blue": {
    divideColor: "divide-light-blue-600",
  },
  blue: {
    divideColor: "divide-blue-600",
  },
  indigo: {
    divideColor: "divide-indigo-600",
  },
  "deep-purple": {
    divideColor: "divide-deep-purple-600",
  },
  purple: {
    divideColor: "divide-purple-600",
  },
  pink: {
    divideColor: "divide-pink-600",
  },
  red: {
    divideColor: "divide-red-600",
  },
};

export default buttonGroupDividerColor;
